export default __webpack_public_path__ + "static/media/Australian Tanks 1.6.f69b2d4f.png";